import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaBoxOpen,
  FaMapMarkedAlt,
  FaProjectDiagram,
  FaMapPin,
  FaTruckMoving,
  FaPlaneDeparture,
  FaRoute,
} from "react-icons/fa";
import "../styles/Service.css";

const Services = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  const services = [
    {
      name: "Inventory Management",
      icon: <FaBoxOpen className="icon" />,
      description: "Seamless storage & stock updates to optimize your space.",
    },
    {
      name: "Logistics Planning",
      icon: <FaMapMarkedAlt className="icon" />,
      description: "Efficient route planning & coordination for smooth flow.",
    },
    {
      name: "Supply Chain Optimization",
      icon: <FaProjectDiagram className="icon" />,
      description: "Minimize delays & maximize profit through smarter supply.",
    },
    {
      name: "Real-Time Tracking",
      icon: <FaMapPin className="icon" />,
      description: "Track every shipment live with pinpoint accuracy.",
    },
  ];

  const additionalServices = [
    {
      title: "Express Cargo Division",
      desc: "Nationwide cargo solutions",
      icon: <FaTruckMoving className="mini-icon" />,
    },
    {
      title: "Part Load Services",
      desc: "Cost-efficient PAN-India distribution",
      icon: <FaRoute className="mini-icon" />,
    },
    {
      title: "Air Cargo Services",
      desc: "Time-critical air freight",
      icon: <FaPlaneDeparture className="mini-icon" />,
    },
  ];

  const fleetOverview = [
    "Tata Ace, 407, 709, 909, 32ft & 40ft containers",
    "Specialized vehicles: JCB, Trailer trucks",
  ];

  return (
    <section id="services">
      <div className="container mx-auto text-center px-4">
        <h2>Our Services</h2>

        {/* Core services grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mt-12">
          {services.map((service, i) => (
            <div
              key={i}
              className="service-card"
              data-aos="fade-up"
              data-aos-delay={i * 80}
            >
              <div>{service.icon}</div>
              <p className="service-title">{service.name}</p>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>

        {/* Additional Services */}
        <div className="svc-subsection" data-aos="fade-up">
          <h3 className="svc-subtitle">Additional Services</h3>
          <div className="info-grid">
            {additionalServices.map((item, idx) => (
              <div className="info-card" key={idx}>
                <div className="info-head">
                  {item.icon}
                  <span className="info-title">{item.title}</span>
                </div>
                <div className="info-desc">{item.desc}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Fleet Overview */}
        <div className="svc-subsection" data-aos="fade-up">
          <h3 className="svc-subtitle">Fleet Overview</h3>
          <ul className="bullet-list">
            {fleetOverview.map((line, i) => (
              <li key={i} className="bullet-item">
                {line}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Services;
